export function getProRoleName(roleId: number, fallback = 'Unknown role'): string {
    switch (roleId) {
        case 1:
            return 'Pro Restricted';
        case 2:
            return 'Pro User';
        case 3:
            return 'Pro Approver';
        default:
            return fallback;
    }
}
